import create from "zustand"
import { getErrorMessage, isCancelledError } from "helpers/error_helpers"

const toastHandler = create(set => ({
  error: { hasError: false, message: null },
  success: { hasSuccess: false, message: null },
  warnings: { hasWarnings: false, message: null },
  // BDSJEA-312: un error de axios se muestra con el mensaje descriptivo de la
  // API (o uno por tipo si no hay cuerpo), nunca con el texto crudo de axios.
  // La cancelacion, el texto vacio y null/undefined (BDSJEA-541: «limpiar» el
  // error no es un error; para eso esta cleanError) no cambian el estado.
  // «Error inesperado» queda solo para un error real sin informacion.
  setError: error =>
    set(state => {
      if (
        error === null ||
        error === undefined ||
        isCancelledError(error) ||
        error === ""
      )
        return state
      return {
        error: {
          hasError: true,
          message: typeof error === "string" ? error : getErrorMessage(error),
        },
      }
    }),
  cleanError: () => set(() => ({ error: { hasError: false, message: null } })),
  setSuccess: message =>
    set(() => ({
      success: {
        hasSuccess: true,
        message: message || "¡Se ha guardado correctamente!",
      },
    })),
  cleanSuccess: () =>
    set(() => ({ success: { hasSuccess: false, message: null } })),
  setWarnings: message =>
    set(() => ({ warnings: { hasWarnings: true, message: message } })),
  cleanWarnings: () =>
    set(() => ({ warnings: { hasWarnings: false, message: null } })),
}))

export default toastHandler
